import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { ChecklistServicoDropDown } from "../../../../domain/models/checklist_servico_dropdown";
import { DefaultSelectInput } from "../../../../../../common/components/default_select_input";
import { useMemo } from "react";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * Header
 */

type Props = {
  area: string | null;
  atividades: number[] | null;
  status: number | null;
  checklistServicoDropdown: ChecklistServicoDropDown[];
  onChangeArea: (value: string | null) => void;
  onChangeAtividades: (value: number[] | null) => void;
  onChangeStatus: (value: number | null) => void;
  onClear: () => void;
};

export const Header = ({
  area,
  atividades,
  status,
  checklistServicoDropdown,
  onChangeArea,
  onChangeAtividades,
  onChangeStatus,
  onClear,
}: Props) => {
  const checklistStatus = useMemo(() => {
    return [
      {
        id: 0,
        label: 'Todos',
      },
      {
        id: 1,
        label: 'Não iniciado',
      },
      {
        id: 2,
        label: 'Iniciado',
      },
      {
        id: 3,
        label: 'Encerrado',
      },
    ];
  }, [
  ]);

  const selectedAtividades = useMemo(() => {
    if (!atividades || atividades.length === 0) return null;
    return checklistServicoDropdown.filter(x => atividades.includes(x.idChecklistServico));
  }, [
    atividades,
    checklistServicoDropdown,
  ]);

  return (
    <CascateList title="Pesquisar" defaultOpen>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">
          <DefaultInput
            name='area'
            label='Área'
            value={area ?? ''}
            onChangeValue={e => onChangeArea(e.trim() === '' ? null : e)}
          />

          <DefaultMultiAutocomplete
            label="Atividades"
            value={selectedAtividades}
            multiline={true}
            options={checklistServicoDropdown}
            chipMaxLength={35}
            getOptionLabel={x => x.descricao}
            getOptionKey={x => x.idChecklistServico}
            onChange={e => onChangeAtividades(e !== null && e.length > 0 ? e.map(x => x.idChecklistServico) : null)}
          />

          <DefaultSelectInput
            name="status"
            label="Status"
            showSelectionLabel={false}
            options={checklistStatus}
            value={status}
            onChangeValue={e => onChangeStatus(Number(e))}
          />
        </div>

        <div className="w-full flex flex-col items-end">
          <div className="w-[7.5rem]">
            <PrimaryButton buttonColor="yellow" onClick={onClear}>
              Limpar
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}